module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Sopranos-The-S2.75064e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Sopranos-The-S2.jpg
// module id = KZO9
// module chunks = 0